/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_Sampling_DateInputs */

const vi_aroma_sampling_date = /** @type {(inputs: Aroma_Sampling_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày lấy hương`)
};

/**

* @param {Aroma_Sampling_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aroma_sampling_date = /** @type {((inputs?: Aroma_Sampling_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_Sampling_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aroma_sampling_date(inputs)
});